<div class="banner-container" *ngIf="test.bannerUrl">
  <img [src]="test.bannerUrl" alt="Test Banner" class="banner-image">
</div>

<div class="test">
  <h1>{{test.name}}</h1>
  <div class="description">{{test.description}}</div>
  <div *ngIf="test.maxDuration" class="properties">
    <span class="label">Продолжительность: </span>
    <app-time [value]="test.maxDuration"></app-time>
  </div>
  <div align="center">
    <small color="red">Уважаемые пользователи, рекомендуем Вам использовать Google Chrome при прохождении тестирования. В других браузерах в одном из десяти случаев наблюдается нестабильная работа. Приносим свои извинения за неудобства.</small>
  </div>
</div>

<!-- Для анонимных тестов (type = 'ANON') -->
<div *ngIf="!unfinishedExecution && !finishedExecution && test.type === 'ANON'" class="buttons">
  <button mat-raised-button color="primary" (click)="startAnonymousTest()">Начать тестирование</button>
</div>

<!-- Для неанонимных тестов с формой регистрации -->
<div *ngIf="!unfinishedExecution && !finishedExecution && test.type !== 'ANON'" class="register-form">
  <app-test-execution-register-form [urlCode]="urlCode"
                                    [testId]="test.id"
                                    (register)="onExecutionStart($event)">
  </app-test-execution-register-form>
</div>

<!-- Незавершенное выполнение теста -->
<div *ngIf="unfinishedExecution" class="test-execution">
  <div class="title">Тестирование</div>
  <div class="properties">
    <div class="property">
      <span class="label">ФИО: </span>{{unfinishedExecution.studentName}}
    </div>
    <div class="property">
      <span class="label">Начало: </span>{{unfinishedExecution.startDate | date:'dd MMMM yyyy в HH:mm'}}
    </div>
    <div *ngIf="unfinishedExecution.expiryDate" class="property">
      <span class="label">Осталось: </span>
      <app-timer [end]="unfinishedExecution.expiryDate"></app-timer>
    </div>
  </div>
  <div class="buttons">
    <button mat-raised-button color="primary" (click)="onExecutionStart(unfinishedExecution)">Продолжить тестирование</button>
  </div>
</div>

<!-- Завершенное выполнение теста -->
<div *ngIf="finishedExecution" class="test-execution">
  <div class="title">Тестирование завершено</div>
</div>